import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { StatusSelectorDialogData } from '@app/work-order/objects/report-progress-footer/status-selector-dialog/status-selector-dialog';
import { StatusCodesService } from '@app/work-order/objects/status-codes.service';
import { StatusCodeDto } from '@app/generated/model';

@Component({
  selector: 'app-status-selector-dialog',
  templateUrl: './status-selector-dialog.component.html',
  styleUrls: ['./status-selector-dialog.component.scss'],
  standalone: false,
})
export class StatusSelectorDialogComponent implements OnInit {
  public options: StatusCodeDto[] = [];
  public selected: StatusCodeDto | null = null;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: StatusSelectorDialogData,
    public dialogRef: MatDialogRef<StatusSelectorDialogComponent>,
    private statusCodesService: StatusCodesService,
  ) {}

  public ngOnInit(): void {
    this.dialogRef.addPanelClass('dropdown-dialog-wrapper');
    this.sortOptions();
    this.selected = this.data.selected;
  }

  private sortOptions() {
    this.options = this.data.options.sort((a, b) => Number(b.isFavourite) - Number(a.isFavourite));
  }

  public toggleFavourite(option: StatusCodeDto) {
    if (!option.id) {
      return;
    }

    this.statusCodesService.toggleFavouriteStatus(option.id);
    option.isFavourite = !option.isFavourite;
    this.sortOptions();
  }

  public generateLabel(option: StatusCodeDto) {
    return `${option.name} ${option.defaultProgress ? option.defaultProgress + '%' : ''}`;
  }

  public select(option: StatusCodeDto) {
    this.selected = this.selected === option ? null : option;
  }

  public submit(option: StatusCodeDto | null) {
    if (!option) {
      return;
    }

    this.dialogRef.close(option);
  }
}
